import jfetch from '@jontetz/jfetch';

export function postGetTranslations(data) {
    return jfetch.post('/api/translation/gettranslation', data);
}